import { render, staticRenderFns } from "./Bg.vue?vue&type=template&id=58639db0&scoped=true&"
import script from "./Bg.vue?vue&type=script&lang=js&"
export * from "./Bg.vue?vue&type=script&lang=js&"
import style0 from "./Bg.vue?vue&type=style&index=0&id=58639db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58639db0",
  null
  
)

component.options.__file = "Bg.vue"
export default component.exports